<template>
  <div class="px-0 py-0">
    <div class="d-flex align-end bluedarken px-7 py-5 ml-1 header-portal">
      <v-flex class="white--text">
        <h3 class="font-weight-700 lh-16 fs-24 mb-2">
          FDS - FINANCIAL PORTAL
        </h3>
        <span class="fs-18">File Sharing – Knowledge Management</span>
      </v-flex>
    </div>
    <v-container grid-list-xl fluid class="px-8 mt-5">
      <v-row class="card-portal">
        <v-flex xs12 v-if="items.length === 0" class="px-2 my-2">
          <v-card class="rounded-10 elevation-card pt-3 text-center py-6 pt-8">
            <h3>No Data Available</h3>
          </v-card>
        </v-flex>
        <v-flex
          v-else
          xs6
          v-for="(item, index) in items"
          :key="index"
          class="px-2 my-2"
        >
          <v-card class="rounded-10 elevation-card pt-3" height="100%">
            <v-row>
              <v-col cols="6" class="px-8">
                <img
                  v-if="item.icon_name"
                  :src="env + '/images/' + item.icon_name"
                  width="25%"
                  class="mb-2"
                />
                <img
                  v-else
                  src="@/assets/images/icon/folder.svg"
                  width="25%"
                  class="mb-2"
                />
                <p class="fs-16 font-weight-600 primary--text mb-0">
                  <a
                    :href="item.link"
                    target="_blank"
                    class="text-decoration-none"
                  >
                    {{ item.name }}
                  </a>
                </p>
                <span class="font-weight-700 fs-12 bluegrey--text">
                  {{ item.children.length }} Folders Shared
                </span>
              </v-col>
              <v-col cols="6" class="pr-8">
                <v-flex
                  xs12
                  v-for="(child, index) in item.children"
                  :key="index"
                  class="folder my-2 text-left py-1 px-2 rounded-4"
                >
                  <a
                    :href="child.link"
                    target="_blank"
                    class="fs-12 greylight--text"
                  >
                    {{ child.name }}
                  </a>
                </v-flex>
              </v-col>
            </v-row>
          </v-card>
        </v-flex>
      </v-row>
      <v-btn
        style="margin-left: -4px !important"
        color="white"
        dark
        @click="downloadFile"
        class="pa-5 ml-0 mt-2 mb-1 fs-14 font-weight-bold primary--text"
      >
        <img class="mr-2" src="@/assets/images/icon/flag-en.svg" />
        <span
          class="text-decoration-underline"
          style="text-transform: none !important;"
          >Click Here to Access Guidebook</span
        >
      </v-btn>
    </v-container>
    <!-- <v-layout class="box-message">
      <v-btn
        color="white"
        dark
        @click="downloadFile"
        class="pa-5 ml-7 fs-14 font-weight-bold primary--text"
      >
        <img class="mr-2" src="@/assets/images/icon/flag-en.svg" />
        <span
          class="text-decoration-underline"
          style="text-transform: none !important;"
          >Click Here to Access Guidebook</span
        >
      </v-btn>
    </v-layout> -->
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../../mixins/ACLMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin],
  data() {
    return {
      boxMessage: false,
      progressDialogLoading: true,
      breadcrumbs: [
        {
          text: 'FINANCIAL PORTAL',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      items: [],
      doc: '',
      env: process.env.VUE_APP_BASE_URL
    };
  },
  mounted() {
    this.getData();
    this.getDoc();
  },
  methods: {
    getData() {
      return this.$store
        .dispatch('contentPortal/getAll')
        .then(data => {
          this.progressDialogLoading = false;
          console.log(data);
          if (data.code === 200) {
            this.items = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    async getDoc() {
      this.progressDialogLoading = true;
      this.loading = true;
      await this.$store
        .dispatch('categoryPortal/getDoc')
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.doc =
              data.data.guideline == null ? '-' : data.data.guideline.file_name;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    downloadFile() {
      let file = encodeURIComponent(this.doc);
      window.open(
        this.env +
          '/v1/download/file?name=' +
          file +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>

<style>
.header-portal {
  background-image: url('../../../assets/images/bg-portal.png');
  background-position: center;
  background-size: cover;
  height: 150px;
}
.card-portal .folder {
  background: #e3ebf3 !important;
}
.box-message {
  position: fixed !important;
  bottom: 73px;
  left: 263px;
  z-index: 2;
}
.box-message .v-speed-dial {
  position: fixed;
  bottom: 5%;
}
.box-message .v-btn--floating {
  position: relative;
}
</style>
